import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Stack } from "@certn/cascadia";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

const styles = {
  requirementList: css({
    marginTop: "var(--space-1)",
    marginBottom: 0,
    paddingLeft: "var(--space-7)",
  }),
  noBorderFooter: css({
    "& > div": {
      borderTopWidth: 0,
    },
  }),
};

interface AddressIncompleteModalProps {
  isOpen: boolean;
  missingRequirements: string[];
  onAcknowledge: () => void;
}

export function AddressIncompleteModal({
  isOpen,
  missingRequirements,
  onAcknowledge,
}: AddressIncompleteModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen}>
      <Dialog width={560}>
        <DialogHeader
          hideDivider
          onClose={onAcknowledge}
          testID="address-incomplete-modal"
        >
          {t("Your address history is incomplete")}
        </DialogHeader>

        <DialogContent testID="address-incomplete-modal-content">
          <Stack gap="space-4">
            <div>
              <Text style="form/body-primary" color="text-base">
                {t("You haven't added the following address requirements:")}
              </Text>
              <ul className={styles.requirementList}>
                {missingRequirements.map((requirement) => (
                  <li key={requirement}>
                    <Text style="form/body-primary" color="text-base">
                      <strong>{requirement}</strong>
                    </Text>
                  </li>
                ))}
              </ul>
            </div>

            <Text style="form/body-primary" color="text-base">
              {t(
                "Providing this information helps us complete your background check more quickly and accurately."
              )}
            </Text>

            <Text style="form/body-primary" color="text-base">
              {t(
                "If you don't have this information, you can continue by confirming this on the previous page. Continuing without an address may lead to incomplete results, which will be noted in your final report."
              )}
            </Text>
          </Stack>
        </DialogContent>

        <div className={styles.noBorderFooter}>
          <DialogFooter>
            <PrimaryButton
              onPress={onAcknowledge}
              testID="address-incomplete-modal-okay"
            >
              {t("Okay")}
            </PrimaryButton>
          </DialogFooter>
        </div>
      </Dialog>
    </Modal>
  );
}
